<style>
.card .card-body {
  padding: 1rem;
}
.el-table .selected-row {
  background: #dbdbdb;
  font-weight: bold;
  color: #009ef7;
}
</style>

<template>
  <div class="card">
    <div class="card-header" style="min-height: 50px; padding: 0 1.25rem">
      <div class="card-title">
        <div style="float: left;">
        <el-date-picker
          v-model="SelectedCalendar"
          type="daterange"
          unlink-panels
          range-separator=":"
          start-placeholder="เริ่ม"
          end-placeholder="สิ้นสุด"
          :shortcuts="shortcuts"
          format="DD/MM/YYYY"
          style="width: 250px"
          @change="getTransferReturnHeadByDate"
        >
        </el-date-picker>
        </div>
                <div style="float: left; margin-left: 50px;">
                  <role-view :roles="['admin']" v-if="!basePartnerCode">
                  <el-select 
                    v-model="filter.partnerCode" 
                    placeholder="เลือกพาร์ทเนอร์"
                    :loading="searchingPartner"
                    clearable
                    filterable
                    @change="getTransferReturnHead">
                    <el-option
                      v-for="partnerOption in arrPartnerOption"
                      :key="partnerOption.partnerCode"
                      :label="partnerOption.partnerName"
                      :value="partnerOption.partnerCode"                
                    >
                      <span style="float: left">{{ partnerOption.partnerCode }}</span>
                      <span
                        style="
                          float: right;
                          color: var(--el-text-color-secondary);"
                        >{{ partnerOption.partnerName }}</span
                      >
                    </el-option>
                  </el-select>  
                  </role-view>
                </div>        
      </div>
      <div class="card-toolbar">   
          <role-view roles="admin">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_add_customer"
              @click="callStock('C')"
            >
              คืนสินค้า
            </button>  
            <button
              type="button"
              class="btn btn-warning ms-5"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_add_customer"
              @click="callStock('M')"
              :disabled="SelectedTFCode=='0' || SelectedIsCancel"
            >
              แก้ไข
            </button>                       
          </role-view>          
          <div class="d-flex flex-column ms-5">
            <print-transfer-button 
              class="btn-btn-primary"
              :transferCode="SelectedTFCode"
              :transferBranch="SelectedBranchID"
              :disabled="SelectedTFCode=='0' || SelectedIsCancel">
            </print-transfer-button> 
          </div>  
          <role-view roles="admin">
            <button
              type="button"
              class="btn btn-danger ms-5"
              data-bs-toggle="modal"
              data-bs-target="#kt_modal_add_customer"
              :disabled="SelectedTFCode=='0' || SelectedIsCancel"
              @click="calcelTransferStore"
            >
              <i class="fa fa-times"></i>
              ยกเลิก
            </button>            
          </role-view>                            
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-4">
          <el-table
            :data="transferStore"
            border
            style="width: 100%; cursor: pointer"
            :cell-style="{ padding: '0', height: '45px' }"
            :height="windowHeight"
            :row-class-name="SelectedRowClassName"
            @row-click="handleSelectionChangeHead"
            v-loading="loadingHead"
            element-loading-text="Loading"
            element-loading-spinner="el-icon-loading"
          >
            <el-table-column prop="tfDate" label="วันที่" width="100px">
              <template v-slot="scope">
                <span class="text-primary" v-if="!scope.row.tfIsCancel">{{ formatDateFromISO(scope.row.tfDate) }}</span>
                <span class="text-danger" v-if="scope.row.tfIsCancel">{{ formatDateFromISO(scope.row.tfDate) }}</span>                
              </template>
            </el-table-column>
            <el-table-column
              prop="tfCode"
              label="ใบคืน/ย้ายสินค้า"
            >
            <template #default="scope">  
              <span class="text-primary" v-if="!scope.row.tfIsCancel">{{ scope.row.tfCode }}</span>
              <span class="text-danger" v-if="scope.row.tfIsCancel">{{ scope.row.tfCode }}</span>
            </template>            
            </el-table-column>
            <el-table-column
              prop="tfToWarehouseName"
              label="คลังปลายทาง"
            >
            <template #default="scope">  
              <span class="text-primary" v-if="!scope.row.tfIsCancel">{{ scope.row.tfToWarehouseName }}</span>
              <span class="text-danger" v-if="scope.row.tfIsCancel">{{ scope.row.tfToWarehouseName }}</span>
            </template>            
            </el-table-column>            
          </el-table>
        </div>
        <div class="col-8">
          <el-table
            :data="transferStoreD"
            border
            style="width: 100%"
            :cell-style="{ padding: '0', height: '45px' }"
            :height="windowHeight"
            show-summary
            :summary-method="summary"            
          >
            <el-table-column
              prop="tfdLineNO"
              label="#"
              width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="tfdProdName"
              label="ชื่อสินค้า"
            ></el-table-column>
            <el-table-column
              prop="productThickness"
              label="หนา"
              align="right"
              width="80"
            >
              <template v-slot="scope">
                {{ numberWithCommas(scope.row.productThickness) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="tfdQuantity"
              label="จำนวน"
              align="right"
              width="100"
            >
              <template v-slot="scope">
                {{ numberWithCommas(scope.row.tfdQuantity, 0) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="tfdWeight"
              label="น้ำหนัก"
              align="right"
              width="100"
            >
              <template v-slot="scope">
                {{ numberWithCommas(scope.row.tfdWeight, 2) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/ApiService";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { numberWithCommas, formatDateFromISO } from "@/utils";
import RoleView from '../../components/RoleView.vue';
 import PrintTransferButton from '../../components/forms/PrintTransferButton.vue';

export default {
  props: {
    basePartnerCode: {
      type: String
    }
  },
  components: {
    RoleView,
    PrintTransferButton
  },  
  mounted: function () {
    setCurrentPageBreadcrumbs("คืนสินค้า", []);
    if(this.basePartnerCode)
    {
      this.filter.partnerCode = this.basePartnerCode;
    }
    const start = new Date();
    const end = new Date();
    this.SelectedCalendar = [new Date(), new Date()];

    this.searchPartner("");
    this.getTransferReturnHead();
    
  },
  data() {
    return {
      windowHeight: window.innerHeight - 285,
      SelectedHeadID: "",
      loadingHead: false,
      SelectedTFCode: "",
      SelectedBranchID: 0,
      SelectedReceiveBy: null,
      SelectedIsCancel: false,
      transferStore: [],
      transferStoreD: [],
      SelectedCalendar: [],
      arrPartnerOption: [],
      searchingPartner: false,
      SelectedTFPartnerCode: "",
      filter: {
        partnerCode: ""
      },      
      shortcuts: [
        {
          text: "วันนี้",
          value: [new Date(), new Date()],
        },
        {
          text: "เมื่อวาน",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() - 1);
            end.setDate(end.getDate() - 1);
            return [start, end];
          })(),
        },
        {
          text: "สัปดาห์นี้",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() + 1 - start.getDay());
            end.setDate(start.getDate() + 6);
            return [start, end];
          })(),
        },
        {
          text: "สัปดาห์ที่แล้ว",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setDate(start.getDate() + 1 - start.getDay());
            start.setDate(start.getDate() - 7);
            end.setDate(start.getDate() + 6);
            return [start, end];
          })(),
        },
        {
          text: "เดือนนี้",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth(), 1);
            end.setMonth(start.getMonth() + 1, 0);
            return [start, end];
          })(),
        },
        {
          text: "เดือนที่แล้ว",
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 1, 1);
            end.setMonth(start.getMonth() + 1, 0);
            return [start, end];
          })(),
        },
      ],
    };
  },
  methods: {
    getTransferReturnHead: async function () {
      this.loadingHead = true;
      this.SelectedTFCode = "0";
      this.SelectedBranchID = 0;    
      this.transferStoreD = [];  
      try {
        const { data } = await ApiService.query(
          "transferstore/GetTransferReturnHead?SDate=" +
            new Date(
        this.SelectedCalendar[0].setDate(this.SelectedCalendar[0].getDate())
      )
        .toISOString()
        .split("T")[0] +
            "&EDate=" +
            new Date(
        this.SelectedCalendar[1].setDate(this.SelectedCalendar[1].getDate())
      )
        .toISOString()
        .split("T")[0] +
        "&PartnerCode=" + this.filter.partnerCode
        );
        this.transferStore = data;
      } catch (error) {
        console.log(error);
      }
      this.loadingHead = false;
    },
    getTransferReturnHeadByDate: function (e) {
      this.startDate = new Date(
        this.SelectedCalendar[0].setDate(this.SelectedCalendar[0].getDate())
      )
        .toISOString()
        .split("T")[0];
      this.endDate = new Date(
        this.SelectedCalendar[1].setDate(this.SelectedCalendar[1].getDate())
      )
        .toISOString()
        .split("T")[0];
      this.getTransferReturnHead();
    },
    getTransferStoreDetail: async function () {
      try {
        this.loading = true;
        this.transferStoreD = [];
        const { data } = await ApiService.query(
          "transferstore/GetTransferStoreDetail?code=" +
            this.SelectedTFCode +
            "&branch=" +
            this.SelectedBranchID
        );
        this.transferStoreD = data;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    callStock(event) {
      ApiService.query("transferstore/CheckTransferReceive?Code=" + this.SelectedTFCode + "&PartnerCode=" + this.SelectedTFPartnerCode)
      .then((res) => {
        if(res.data["success"] == true){
          this.$router.push({ name: "returnproduct" , params: { mode: event, voucherCode: this.SelectedTFCode, voucherBranch: this.SelectedBranchID} });
        }
        else
        {
                            this.$swal.fire({
                              icon: 'error',
                              text: (res.data["error_Text"] != "") ? res.data["error_Text"] : "ไม่สามารถทำรายการได้ กรุณาติดต่อ Admin",
                              timer: 1500,  
                              showConfirmButton: false, 
                              allowOutsideClick: false,         
                            })
        }
      })
      
    },   
    handleSelectionChangeHead(val) {
      this.SelectedTFCode = val.tfCode;
      this.SelectedBranchID = val.tfBranchID;
      this.SelectedReceiveBy = val.tfReceiveBy;
      this.SelectedIsCancel = val.tfIsCancel;
      this.SelectedTFPartnerCode = val.tfPartnerCode;
      this.getTransferStoreDetail();
    },
    SelectedRowClassName({ row, rowIndex }) {
      if (row.tfCode === this.SelectedTFCode) {
        return "selected-row";
      }
      return "";
    },
    numberWithCommas,
    formatDateFromISO,
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 1) {
          sums[index] = data.length + ' รายการ';
        }

        
        if(col.property == "tfdQuantity") {
          sums[index] = data.reduce(
            (prev, curr) => {
              return prev + curr[col.property]
            },
            0
          ) + ' เส้น';
        }

        if(col.property == "tfdWeight") {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + curr[col.property]
            },
            0
          )) + ' กก.';
        }        
      })   

      return sums;
    }, 
    searchPartner: async function(query)
    {
      this.searchingPartner = true;
      const {data} = await ApiService.query("data-options/partners", {query})
      this.arrPartnerOption = data
      this.searchingPartner = false;
    },   
    calcelTransferStore(){
            ApiService.query("transferstore/CheckTransferReceive?Code=" + this.SelectedTFCode + "&PartnerCode=" + this.SelectedTFPartnerCode)
            .then((res) => {
              if(res.data["success"] == true){
                this.$swal.fire({
                    icon: 'question',
                    title: 'ต้องการยกเลิกใบย้าย ' + this.SelectedTFCode,
                    showCancelButton: true,
                    confirmButtonText: "ยืนยัน",
                    cancelButtonText: "กลับ"
                })
                .then( result => {
                    if(result.isConfirmed) {
                      const loader = this.$loading.show();
                      ApiService.query("transferstore/CancelTransferStore?Code=" + this.SelectedTFCode + "&BranchID=" + this.SelectedBranchID + "&PartnerCode=" + this.filter.partnerCode)
                      .then((res) => {
                          if(res.data["success"] == 1){
                              this.$swal.fire({
                                  icon: 'success',
                                  text: res.data["error_Text"],
                                  timer: 1500,  
                                  showConfirmButton: false, 
                                  allowOutsideClick: false,         
                              })

                              this.getTransferReturnHead();
                          }
                          else
                          {
                            this.$swal.fire({
                              icon: 'error',
                              text: (res.data["error_Text"] != "") ? res.data["error_Text"] : "ไม่สามารถทำรายการได้ กรุณาติดต่อ Admin",
                              timer: 1500,  
                              showConfirmButton: false, 
                              allowOutsideClick: false,         
                            })
                          }                        
                      })
                      .catch(err => {
                          console.log(err)
                      })
                      .finally(() => {
                          loader.hide();
                      });
                    }
                })
              }
              else
              {
                           this.$swal.fire({
                            icon: 'error',
                            text: (res.data["error_Text"] != "") ? res.data["error_Text"] : "ไม่สามารถทำรายการได้ กรุณาติดต่อ Admin",
                            timer: 1500,  
                            showConfirmButton: false, 
                            allowOutsideClick: false,         
                          })                
              }
            })
    }    
  },
};
</script>
